import { StatePreV16, StateV16 } from './16_migrate_warenkorb_breed_label.interface';

const BREED_LABEL_CORRECTIONS: [string, string][] = [
  ['Pyrenäen-Schäferhund Mix', 'Pyrenäenschäferhund Mix'],
  ['Pyrenäen-Schäferhund', 'Pyrenäenschäferhund'],
  ['Berger de Picaderie', 'Berger de Picardie'],
  ['Havanerser', 'Havaneser'],
  ['Rhodesian RIdgeback', 'Rhodesian Ridgeback'],
  ['Rauhhaardackel', 'Rauhaardackel'],
  ['Barbancon', 'Brabancon'],
  ['Jack Russel Terrier', 'Jack Russell Terrier'],
  ['Komodor', 'Komondor'],
  ['Labardor Retriever', 'Labrador Retriever'],
  ['Parson Russel Terrier', 'Parson Russell Terrier'],
  ['Fox Terrier (Glatthaar)', 'Foxterrier (Glatthaar)'],
];

const correctBreedLabels = (versichertesRisiko: string): string => {
  if (!versichertesRisiko) {
    return versichertesRisiko;
  }
  return BREED_LABEL_CORRECTIONS.reduce(
    (result, [oldLabel, newLabel]) => result.split(oldLabel).join(newLabel),
    versichertesRisiko,
  );
};

export const migrateWarenkorbBreedLabel = (
  previousState: StatePreV16,
  newVersion: number,
): StateV16 => {
  const migratedWarenkorb = previousState.warenkorb.map(angebot => ({
    ...angebot,
    versichertesRisiko: correctBreedLabels(angebot.versichertesRisiko),
  }));

  return {
    ...previousState,
    version: newVersion,
    warenkorb: migratedWarenkorb,
  };
};
